import { ArrowRight, Shield } from 'lucide-react';
import { HeroIllustration } from './svg/HeroIllustration';

export function HeroSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-purple-600 min-h-[90vh] flex items-center overflow-hidden">
      {/* Grid texture background */}
      <div className="absolute inset-0 opacity-[0.15]" aria-hidden="true">
        <svg className="absolute inset-0 h-full w-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hero-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hero-grid)" />
        </svg>
      </div>

      {/* Main Content */}
      <div className="relative py-20 md:py-32 w-full">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left: Text content */}
            <div className="text-center lg:text-left">
              {/* Badge */}
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm text-white">
                <Shield className="h-4 w-4 text-white" />
                <span>CFTC Compliance Made Simple</span>
              </div>

              {/* Headline */}
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-white drop-shadow-lg">
                Never Miss a{' '}
                <span className="text-white underline decoration-purple-300 decoration-4 underline-offset-4">
                  Position Limit
                </span>{' '}
                Again
              </h1>

              {/* Subheadline */}
              <p className="mt-6 text-lg text-white/80 md:text-xl max-w-2xl lg:max-w-none">
                Real-time CFTC compliance monitoring for commodity traders. Stop spreadsheet chaos. Prevent costly breaches.
              </p>

              {/* CTAs */}
              <div className="mt-10 flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-4">
                <a
                  href="#waitlist"
                  onClick={(e) => scrollToSection(e, '#waitlist')}
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-purple-700 shadow-lg hover:bg-purple-50 transition-colors w-full sm:w-auto"
                >
                  <span>Join the Waitlist</span>
                  <ArrowRight className="h-4 w-4" />
                </a>
                <a
                  href="#demo"
                  onClick={(e) => scrollToSection(e, '#demo')}
                  className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 bg-white/10 px-8 py-4 text-base font-semibold text-white hover:bg-white/20 hover:border-white/50 transition-colors w-full sm:w-auto"
                >
                  Schedule a Demo
                </a>
              </div>

              {/* Trust indicators */}
              <p className="mt-12 text-sm text-white/60">
                Trusted by compliance teams at leading commodity trading firms
              </p>
            </div>

            {/* Right: Illustration */}
            <div className="hidden lg:block">
              <HeroIllustration className="w-full h-auto max-w-lg mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
